import { CurrentIndexChangeEvent } from '../../adapter';
import { Utils } from '../../utils';
import { PropertyChangeEventName } from '../../events';
import { PacemEventTarget } from '../../eventtarget';
import { PacemElement } from './types';
export class PacemAdapter extends PacemElement {
    constructor() {
        super(...arguments);
        this._propertyChangeHandler = (evt) => {
            this.masterPropertyChangedCallback(evt.detail.propertyName, evt.detail.oldValue, evt.detail.currentValue, evt.detail.firstChange);
        };
    }
    /** Gets the adapted element. */
    get master() {
        return this._element;
    }
    /** Gets whether this adapter has been initialized or not. */
    get initialized() {
        return !Utils.isNull(this._element);
    }
    /**
     * Handles the property changes for the master element.
     * @param name Name of the property that has changed
     * @param old Previous value
     * @param val Current value
     * @param first Is it the startup change?
     */
    masterPropertyChangedCallback(name, old, val, first) {
        switch (name) {
            case 'items':
                this._adjustFocusIndex();
                break;
            case 'index':
                this._element.dispatchEvent(new CurrentIndexChangeEvent({ currentIndex: val, previousIndex: old }));
                break;
        }
    }
    /**
     * Handles the property changes for item elements.
     * @param index Index of the element among the items
     * @param name Name of the property that has changed
     * @param old Previous value
     * @param val Current value
     * @param first Is it the startup change?
     */
    itemPropertyChangedCallback(index, name, old, val, first) {
        // empty implementation
    }
    /** Called righat after the adapter 'initialize'. */
    initializeCallback() {
        // empty implementation
    }
    destroyCallback() {
        // empty implementation
    }
    initialize(adapted) {
        if (this._element != null) {
            this.destroy();
            //throw `Cannot initialize an adapter twice.`;
        }
        if (adapted != null) {
            this._element = adapted;
            this._element.addEventListener(PropertyChangeEventName, this._propertyChangeHandler, false);
        }
        this.initializeCallback();
    }
    destroy() {
        if (this._element != null)
            this._element.removeEventListener(PropertyChangeEventName, this._propertyChangeHandler, false);
        this.destroyCallback();
    }
    disconnectedCallback() {
        this.destroy();
        super.disconnectedCallback();
    }
    _adjustFocusIndex() {
        let items = this._element.items;
        const index = this._element.index;
        const length = items && items.length;
        const ndxStart = length ? Math.max(0, Math.min(length - 1, index)) : -1;
        const ndx = this._getAvailable(ndxStart);
        this._element.index = ndx;
    }
    _getNextAvailable(ndxStart) {
        return this._getAvailable(ndxStart, 1);
    }
    _getPreviousAvailable(ndxStart) {
        return this._getAvailable(Math.max(0, ndxStart), -1);
    }
    _getAvailable(ndxStart = this._element && this._element.index, step = 0) {
        let items = this._element.items, length;
        if (!(items && (length = items.length) > 0))
            return -1;
        ndxStart = ndxStart % length;
        let ndx = (ndxStart + step + length) % length;
        let item;
        step = step || -1;
        while ((item = items[ndx]) instanceof PacemEventTarget && item.disabled === true
            || (item instanceof PacemElement && item.hide === true)) {
            ndx = (ndx + step + length) % length;
            if (ndx == ndxStart) {
                // loop completed
                return -1;
            }
        }
        return ndx;
    }
    /**
     * Returns whether the provided index is close (adjacent or equal) to the current one in focus.
     * @param ndx index to be checked
     */
    isClose(ndx) {
        const current = this._getAvailable();
        return ndx === current
            || ndx === this._getPreviousAvailable(current)
            || ndx === this._getNextAvailable(current);
    }
    /**
     * Returns whether the provided index is adjacent (previous on the list) to the current one in focus.
     * @param ndx index to be checked
     */
    isPrevious(ndx) {
        const current = this._getAvailable();
        return ndx === this._getPreviousAvailable(current);
    }
    /**
     * Returns whether the provided index is adjacent (next on the list) to the current one in focus.
     * @param ndx index to be checked
     */
    isNext(ndx) {
        const current = this._getAvailable();
        return ndx === this._getNextAvailable(current);
    }
    select(ndx) {
        this._element.index = this._getAvailable(ndx);
    }
    previous(loop = true) {
        var prev = this._getPreviousAvailable(this._element.index);
        if (prev >= 0 && (loop || this._element.index > prev))
            this._element.index = prev;
    }
    next(loop = true) {
        var next = this._getNextAvailable(this._element.index);
        if (next >= 0 && (loop || this._element.index < next))
            this._element.index = next;
    }
}
//}
